
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import detallesarticulo from './articulos/articulos-detalles.vue';
    import turnero from './turnero/turnero.vue';




    @Component( {
        name: "Componente",
        props: {},
        components: {
            detallesarticulo,
            turnero,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get BarraDerecha() { return this.Controlador.Vista.BarraDerecha; }
        public get SubModo() { return this.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.BarraDerecha.SubModo = x; }
        public get Modo() { return this.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.BarraDerecha.Modo = x; }

        public get Abierto() { return this.BarraDerecha.Abierto; }
        public set Abierto( x: boolean ) { this.BarraDerecha.Abierto = x; }

        public get Anchura() { return this.BarraDerecha.Anchura.Espacio; }
        public set Anchura( x: string | number ) { this.BarraDerecha.Anchura.Espacio = x; }

        public get Altura() { return this.BarraDerecha.Altura.Espacio; }
        public set Altura( x: string | number ) { this.BarraDerecha.Altura.Espacio = x; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {

            this.Anchura = '400px';
            this.Abierto = true;
            this.Eventos.push( this.BarraDerecha.onAbierto.subscribe( () =>
            {

                //if ( !this.Abierto )
                //    this.EspacioDerecha= 0;

            } ) );


            this.Eventos.push( this.BarraDerecha.onModo.subscribe( () =>
            {
                if ( this.Modo )
                {
                    //ControladorPrincipal.Vista.OcultarMenu();
                    this.Abierto = true;
                } else
                {
                    //ControladorPrincipal.Vista.MenuOculto = false;
                    this.Abierto = false;
                }



            } ) );


        }

    }
